import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idLeadCorretor: string;
}

export interface LeadDadosCompInterface {
  idLeadCorretor: string;
  idLead: string;
  dataNascimento: string;
  idProfissao: string;
  profissao: string;
  idEstadoCivil: string;
  estadoCivil: string;
  idRendaFamiliar: string;
  rendaFamiliar: string;
  idSexo: string;
  sexo: string;
  idObjetivoCompra: string;
  objetivoCompra: string;
  cep: string;
  cidade: string;
  bairro: string;
}

export function useDadosComplementaresV2(props: Props & QueryGlobalInterface) {
  const fetchData = async () => {
    const DADOS_COMPLEMENTARESV2 = `${leadsWebEnviroment}/commom/leads/dados-complementares/v2/${props.idLeadCorretor}`;
    const response = await instance.get(DADOS_COMPLEMENTARESV2);

    return response?.data?.data?.dataResponse as LeadDadosCompInterface;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar dados complementares. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
